import { useQuery } from '@tanstack/react-query';
import { parentApi } from '../api/parentApi';
import type { RecapResponse } from '../types/recap';

export function useWeeklyRecap(studentId: string | undefined) {
  return useQuery<RecapResponse>({
    queryKey: ['parent', 'recap', studentId],
    queryFn: () => parentApi.getWeeklyRecap(studentId as string),
    enabled: !!studentId,
    staleTime: 30 * 60 * 1000,    // 30 min — backend caches 1h, half is comfortable
    gcTime: 60 * 60 * 1000,
  });
}
